import { render, staticRenderFns } from "./Measurement.vue?vue&type=template&id=0b80227b&scoped=true&"
import script from "./Measurement.vue?vue&type=script&lang=js&"
export * from "./Measurement.vue?vue&type=script&lang=js&"
import style0 from "./Measurement.vue?vue&type=style&index=0&id=0b80227b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b80227b",
  null
  
)

export default component.exports